import { H4, UL } from "../../../../AbstractElements";
import { SidebarIcon } from "../../../../Constant";
import { useAppDispatch } from "../../../../Redux-Toolkit/Hooks";
import { addSidebarIconType } from "../../../../Redux-Toolkit/Reducers/ThemeCustomizerSlice";
import ConfigDB from "../../../../config/ThemeConfig";
import FillIcon from "./FillIcon";
import StrokeIcon from "./StrokeIcon";

const SidebarIconType = () => {
  const dispatch = useAppDispatch();
  const sideBarIconType = ConfigDB.data.settings.sidebar.iconType;

  const handleSideBarIconType = (type: string) => {
    dispatch(addSidebarIconType(type));
  };

  return (
    <div>
      <H4>{SidebarIcon}</H4>
      <UL className="sidebar-type layout-grid simple-list d-flex flex-row">
        <StrokeIcon handleSideBarIconType={handleSideBarIconType} sideBarIconType={sideBarIconType} />
        <FillIcon handleSideBarIconType={handleSideBarIconType} sideBarIconType={sideBarIconType} />
      </UL>
    </div>
  );
};

export default SidebarIconType;
